import React from 'react';
import qs from 'qs';
import { observer } from 'mobx-react';
import { Helmet } from 'react-helmet';

import callApi from '../../utils/callApi';
import { capitalizeFirstChar, sanitizeHTMLString } from '../../utils/helpers';
import {
  ARHIVE_LIST,
  ARHIVE_LIST_BY_SEGMENT,
  ARHIVE_LIST_BY_ANCHOR,
  ARHIVE_LIST_BY_VINTAGE,
  ARHIVE_LIST_BY_DATE,
  SEGMENTS_LIST,
  VINTAGE_LIST,
  ARHIVE_LIST_BY_TEXT,
  ARCHIVES_LIST_BY_TAGNAME,
} from '../../constants/apiUrls/apiUrls';
import ArchiveDateStore from '../../store/ArchiveDateStore';
import Pagination from '../../components/arhiveComponents/Pagination';
import TransparentLoader from '../../components/Loaders/TransparentLoader';

import ArchivesList from './ArchivesList/ArchivesList';
import ArchivesVideoPlayer from './ArchivesVideoPlayer/ArchivesVideoPlayer';
import { parseSlug } from './archives-utils/archivesUtils';


import './css/Archives.css';
import styles from './css/Archives.module.css';
import ArchivesHeader from './ArchivesHeader/ArchivesHeader';

import AnchorStore from '../../store/AnchorStore';
import ArchiveStore from '../../store/ArchiveStore';
import VideoPlayerStore from '../../store/VideoPlayerStore';
import { archivesTitle } from '../../constants/Constants';


class Archives extends React.Component {

  state = {
    typeOfListing: 'all',
    arhives: [],
    isLoading: true,
    showVideo: false,
    showSegmentList: false,
    videoElement: null,
    listingId: null,
    listingYear: null,
    listingMonth: null,
    listingTitle: null,
    currentPageNumber: 1,
    totalNumberOfEntries: null,
    entriesPerPage: 36,
    vintageSlugPrefix: '',
    programSegmentId: '',
    searchSegmentId: null,
    searchAnchorId: null,
    searchFullText: null,
    segments: [],
    vintage: [],
    currentPathname: '',
    searchParams: '',
  };

  saveStateKey = (key, value) => {
    this.setState({ [key]: value }, () => this.fetchArhives());
  };

  setTypeOfListing = (type, id, title) => {
    const { typeOfListing, listingId } = this.state;

    if (type !== typeOfListing || listingId !== id) {
      this.setState(
        {
          typeOfListing: type,
          listingId: id,
          listingYear: null,
          listingMonth: null,
          listingTitle: title,
          showVideo: false,
          showSegmentList: false,
          isLoading: true,
          videoElement: null,
        },
        () => this.fetchArhives()
      );
    }
  };

  setTypeOfListingForDate = (type, year, month) => {
    const { typeOfListing, listingYear, listingMonth } = this.state;

    const parsedListingTitle = `${ArchiveDateStore.months[month * 1 - 1].name} ${year}`;
    if (
      type !== typeOfListing ||
      year !== listingYear ||
      month !== listingMonth
    ) {
      this.setState(
        {
          typeOfListing: type,
          listingId: null,
          listingYear: year,
          listingMonth: month,
          listingTitle: parsedListingTitle,
          showVideo: false,
          showSegmentList: false,
          videoElement: null,
        },
        () => this.fetchArhives()
      );
    }
  };

  componentDidUpdate(prevProps) {
    const { location: prevLocation } = prevProps;
    const { location } = this.props;
    if ((prevLocation?.pathname !== location?.pathname) || (prevLocation?.search !== location?.search)) {
      this.onArchivePageUpdate();
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  getIdFromUrl = () => {
    const { location } = this.props;
    const parsedSearch = qs.parse(location.search, { ignoreQueryPrefix: true });

    return parsedSearch.segmentid || parsedSearch.anchorid;
  };

  formatUrlWithTagname = (tag) => ARCHIVES_LIST_BY_TAGNAME.replace('{tagName}', tag);

  fetchProgramsByTagName = () => {
    const { match } = this.props;
    const { currentPageNumber, entriesPerPage } = this.state;
    callApi(this.formatUrlWithTagname(match?.params?.tag), 'GET', { page: currentPageNumber - 1, size: entriesPerPage }, {}, {}, true, true).
      then((res) => {
        this.setState({
          isLoading: false,
          arhives: res.data.segments,
          totalNumberOfEntries: res.data.count,
        });
      });
  };

  fetchArhives = () => {
    const { match } = this.props;
    const url = this.decideUrl();
    if (match?.params?.tag?.length) {
      this.fetchProgramsByTagName();

      return;
    }
    this.fetchArhiveListByTypeOfListing(url);
  };

  fetchArhivesFromLocation = () => {
    const { location, history, slug, match } = this.props;
    const { anchors } = AnchorStore;
    const {
      entriesPerPage,
      currentPageNumber,
      listingMonth,
      programSegmentId,
    } = this.state;

    if (location.search || (match && match.params.slug)) {
      let anchor = {};
      if (match && match.params && match.params.slug) {
        anchor = anchors.guestAnchors.find((anch) => anch.shortUrl && anch.shortUrl.toLowerCase() === match.params.slug.toLowerCase()) ||
          anchors.pastAnchors.find((anch) => anch.shortUrl && anch.shortUrl.toLowerCase() === match.params.slug.toLowerCase()) ||
          anchors.currentAnchors.find((anch) => anch.shortUrl && anch.shortUrl.toLowerCase() === match.params.slug.toLowerCase());
      }
      const id = this.getIdFromUrl() || anchor.id;
      let baseUrl = ARHIVE_LIST_BY_SEGMENT;
      const searchByAnchor = location.search.includes('anchorid') || !!anchor.id;
      if (searchByAnchor) {
        baseUrl = ARHIVE_LIST_BY_ANCHOR;
      }

      const parsedUrl = baseUrl.
        replace('{page}', currentPageNumber - 1).
        replace('{size}', encodeURIComponent(entriesPerPage)).
        replace('{id}', encodeURIComponent(id)).
        replace('{month}', encodeURIComponent(listingMonth));
      callApi(parsedUrl, 'get', {}).then((res) => {
        if (res.data.segments) {
          if (!slug && baseUrl === ARHIVE_LIST_BY_SEGMENT && id === '219') {
            history.replace(parseSlug(res.data.segments[0], 'segment', id));

            return;
          }
          const videoElement = anchor.id ? res.data.segments[0] : this.getVideoElementById(
            res.data.segments
          );

          if (anchor.id) {
            this.setState({ showVideo: true });
          }

          this.setState({
            arhives: res.data.segments,
            isLoading: false,
            totalNumberOfEntries: res.data.count || entriesPerPage,
            videoElement: videoElement || { programSegmentId },
            showSegmentList: true,
            listingId: id,
            typeOfListing: searchByAnchor ? 'anchor' : 'segment',
            searchAnchorId: searchByAnchor && id,
            searchSegmentId: location.search.includes('segmentid') && id,
          });
        }
      });
    }
  };

  decideUrl = () => {
    const { typeOfListing } = this.state;
    let url = '';

    switch (typeOfListing) {
      case 'segment':
        url = ARHIVE_LIST_BY_SEGMENT;
        break;
      case 'anchor':
        url = ARHIVE_LIST_BY_ANCHOR;
        break;
      case 'date':
        url = ARHIVE_LIST_BY_DATE;
        break;
      case 'vintage':
        url = ARHIVE_LIST_BY_VINTAGE;
        break;
      case 'search':
        url = ARHIVE_LIST_BY_TEXT;
        break;
      case 'tag':
        url = ARCHIVES_LIST_BY_TAGNAME;
        break;
      default:
        url = ARHIVE_LIST;
        break;
    }

    return url;
  };

  getVideoElementById = (data) => {
    const { location } = this.props;
    const regex = /-w\d{1,}/;
    const found = location.pathname.match(regex);
    const videoId = found && found[0].replace('-w', '');
    const videoElement = data.filter(
      (segment) => segment.programSegmentId === parseInt(videoId, 10)
    );

    return videoElement[0];
  };

  fetchArhiveListByTypeOfListing = (url) => {
    const {
      entriesPerPage,
      currentPageNumber,
      listingId,
      listingMonth,
      listingYear,
      typeOfListing,
      programSegmentId,
    } = this.state;
    const { slug, location } = this.props;
    const parsedSearch = qs.parse(location.search, { ignoreQueryPrefix: true });
    const idReplace = typeOfListing === 'date' ? listingYear : listingId;

    const parsedUrl = url.
      replace('{page}', currentPageNumber - 1).
      replace('{size}', encodeURIComponent(entriesPerPage)).
      replace('{id}', encodeURIComponent(idReplace)).
      replace('{month}', encodeURIComponent(listingMonth)).
      replace('{searchParam}', encodeURIComponent(parsedSearch.search));

    callApi(parsedUrl, 'get', {}).then((res) => {
      if (res.data.segments) {
        // send video element only with program segment id
        // this is used in case when user come from anchors page
        const videoElement = ['all', 'search'].includes(typeOfListing) && { programSegmentId };
        const slugSplit = slug ? slug.split('/') : [];
        const id =
          slugSplit && slugSplit[1] && slugSplit[1].match(/\d+/)[0];
        this.setState({
          arhives: res.data.segments,
          videoElement: videoElement ||
            res.data.segments.find((seg) => {
              if (typeOfListing === 'vintage') {
                return slug.includes(seg.slug);
              }

              return seg.programSlug === slug;
            }) || { id },
          isLoading: false,
          searchFullText: parsedSearch.search,
          totalNumberOfEntries: res.data.count ? res.data.count : entriesPerPage,
        });
      } else {
        this.setState({
          arhives: res.data,
          isLoading: false,
          searchFullText: parsedSearch.search,
          totalNumberOfEntries: res.data.count ? res.data.count : entriesPerPage,
        });
      }
    });
  };

  onArchivePageUpdate = () => {
    const { location, slug, match } = this.props;
    const { currentPathname, searchParams } = this.state;
    const { anchors } = AnchorStore;
    const { segmentsList: segments, vintageList: vintage } = ArchiveStore;
    if (currentPathname?.length && (currentPathname === location?.pathname) && searchParams?.length && (searchParams === location?.search)) {
      return;
    }
    this.setState({
      currentPathname: this.props.location?.pathname,
      searchParams: location?.search,
      isLoading: true,
    });
    const parsedSearch = qs.parse(location.search, { ignoreQueryPrefix: true });
    if (location.search || (match && match.params.slug)) {
      let selectedSegment;
      let anchor = {};
      if (match && match.params && match.params.slug) {
        anchor = anchors?.guestAnchors.find((anch) => anch.shortUrl && anch.shortUrl.toLowerCase() === match.params.slug.toLowerCase()) ||
          anchors?.pastAnchors.find((anch) => anch.shortUrl && anch.shortUrl.toLowerCase() === match.params.slug.toLowerCase()) ||
          anchors?.currentAnchors.find((anch) => anch.shortUrl && anch.shortUrl.toLowerCase() === match.params.slug.toLowerCase());
      }
      if (!parsedSearch.anchorid && !parsedSearch.segmentid && !anchor) {
        this.props.history.push('/not-found');

        return;
      }
      const anchorid = parsedSearch.anchorid || anchor.id;
      if (parsedSearch.segmentid) {
        selectedSegment = segments.find(
          (segment) =>
            segment?.id ===
            parseInt(parsedSearch.segmentid)
        );
      }
      if (anchorid) {
        selectedSegment = Object.keys(
          anchors
        ).reduce((seg, anchorsListName) => {
          if (seg.name) {
            return seg;
          }

          return (
            anchors[
              anchorsListName
            ].find(
              (anc) =>
                anc.id ===
                parseInt(anchorid)
            ) || {}
          );
        }, {});
      }
      this.setState(
        {
          currentPageNumber: parsedSearch.page || 1,
          listingTitle: selectedSegment ? selectedSegment.name : '',
        },
        () => {
          if (
            parsedSearch.segmentid || anchorid
          ) {
            this.fetchArhivesFromLocation();
          } else {
            this.fetchArhives();
          }
        }
      );
    }
    if (slug) {
      const slugSplit = slug ? slug.split('/') : [];
      if (slug.match(/(-v(\d){2,10})/)) {
        const listingId = slug.
          match(/-v(\d){2,10}/)[0].
          replace('-v', '');
        const selectedVintage = vintage.find(
          (vintage) =>
            vintage.id === parseInt(listingId)
        );
        this.setState(
          {
            typeOfListing: 'vintage',
            showVideo: !!slugSplit[1],
            showSegmentList: true,
            listingId,
            listingTitle: selectedVintage.name,
            vintageSlugPrefix: slugSplit[0],
          },
          () =>
            !location.search && this.fetchArhives()
        );
      } else if (slug.match(/-w\d{2,10}/)) {
        const programSegmentId = slug.
          match(/-w\d{2,10}/)[0].
          replace('-w', '');
        this.setState(
          {
            typeOfListing: 'all',
            showVideo: true,
            showSegmentList: true,
            programSegmentId,
          },
          () =>
            parsedSearch.anchorid ||
              parsedSearch.segmentid ? this.fetchArhivesFromLocation(programSegmentId) : this.fetchArhives()
        );
      } else {
        const currentMonth = ArchiveDateStore.months.find(
          (month) => month.number === slugSplit[1]
        );

        if (!currentMonth) {
          return;
        }

        this.setState(
          {
            typeOfListing: 'date',
            listingYear: slugSplit[0],
            listingMonth: slugSplit[1],
            listingTitle: `${currentMonth.name} ${slugSplit[0]
            }`,
            showVideo: /nude-program/.test(slug),
            showSegmentList: true,
          },
          () => this.fetchArhives()
        );
      }
    }
    if (parsedSearch && parsedSearch.search) {
      this.setState({ typeOfListing: 'search', showVideo: true });
    }
    if (!location.search && !slug && !match.params.slug) {
      this.fetchArhives();
    }
  };

  getTitle = () => {
    const { typeOfListing } = this.state;
    const { match } = this.props;
    const tagNameFormattedForTitle = match?.params?.tag?.length > 0 ? ` #${match?.params?.tag}` : '';
    const defaultTitle = `${archivesTitle[typeOfListing]}${tagNameFormattedForTitle} | Naked News`;
    const title = this.props.slug ? `${capitalizeFirstChar(this.props.slug.replaceAll('-', ' '))} | ${defaultTitle}` : defaultTitle;

    return title;
  };

  handleArchiveTagPage = () => {
    this.setState({ typeOfListing: 'tag' });
  };

  componentDidMount() {
    const { match } = this.props;
    if (match?.params?.tag?.length) {
      this.handleArchiveTagPage();
    }
    Promise.all([
      callApi(SEGMENTS_LIST, 'get', {}),
      callApi(VINTAGE_LIST, 'get', {}),
    ]).
      then(([segments, vintage]) => {
        ArchiveStore.setSegmentsData({
          segments: segments.data,
          vintage: vintage.data,
        });
        this.onArchivePageUpdate();
      });
  }

  getMetaDescription = () => {
    const { programSegments, currentPosition } = VideoPlayerStore;
    if (programSegments?.[currentPosition]?.description?.length) {
      return sanitizeHTMLString(programSegments?.[currentPosition]?.description);
    }

    return 'The Naked News Archives are made up of thousands of past shows. Don\'t miss a day by watching the Best Of Naked News now.';
  };

  render() {
    const {
      arhives,
      typeOfListing,
      totalNumberOfEntries,
      entriesPerPage,
      currentPageNumber,
      listingId,
      listingTitle,
      videoElement,
      showSegmentList,
      searchAnchorId,
      searchSegmentId,
      showVideo,
      programSegmentId,
      searchFullText,
      isLoading,
    } = this.state;
    const { location, slug, match, user } = this.props;
    const shouldRenderVideo =
      !(typeof videoElement === 'undefined' || videoElement === null) &&
      showVideo;
    const { segmentsList, vintageList } = ArchiveStore;

    const showPagination = totalNumberOfEntries > entriesPerPage && !user?.sfw;

    return (
      <div className={styles.content}>
        <Helmet>
          <title>{this.getTitle()}</title>
          <meta content={this.getMetaDescription()} name="description" />
        </Helmet>
        <ArchivesHeader
          history={this.props.history}
          segments={segmentsList}
          setTypeOfListing={this.setTypeOfListing}
          setTypeOfListingForDate={this.setTypeOfListingForDate}
          slug={this.props.slug}
          typeOfListing={typeOfListing}
          user={this.props.user}
          vintage={vintageList}
        />
        {isLoading &&
          <TransparentLoader />
        }
        {shouldRenderVideo && (
          <ArchivesVideoPlayer
            location={location}
            match={match}
            programSegmentId={programSegmentId}
            searchAnchorId={searchAnchorId}
            searchSegmentId={searchSegmentId}
            showSegmentList={showSegmentList}
            slug={slug}
            typeOfListing={typeOfListing}
            user={this.props.user}
            videoElement={videoElement}
          />
        )}
        <ArchivesList
          arhives={arhives}
          listingId={listingId}
          listingTitle={listingTitle}
          match={match}
          searchFullText={searchFullText}
          slug={this.state.vintageSlugPrefix}
          typeOfListing={typeOfListing}
        />
        {showPagination && (
          <Pagination
            key={totalNumberOfEntries}
            activePageNumber={currentPageNumber * 1}
            entriesPerPage={entriesPerPage}
            saveStateKeyParent={this.saveStateKey}
            totalNumber={totalNumberOfEntries}
          />
        )}
      </div>
    );
  }
}

export default observer(Archives);
